var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.799805 6.50005L2.09981 7.90005L5.89981 4.20005V16.9H7.7998V4.20005L11.5998 7.90005L12.9998 6.50005L6.89981 0.800049L0.799805 6.50005Z","fill":"#727272"}));
}

ArrowUp.defaultProps = {"width":"13","height":"17","viewBox":"0 0 13 17","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
